module.exports = __webpack_public_path__ + "static/matui-d1eafea817348dc0a06a9c9e80360949.png";